import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the TimeCheck module.
 */
export const TIME_CHECK_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/time-check',
    labelKey: 'TimeCheck.main',
    icon: '/assets/tablerIcons/outline/clock-check.svg',
    moduleId: 21
  }
];
